<template>
  <div v-if="currentPopup" class="popups-shared">
    <template v-if="currentPopup.id === 'NL-SignUp'">
      <BasicModal class="sm" @close-modal="handleFinished()">
        <template #icon>
          <BasicIcon
            :name="'xmark-solid'"
            class="w-4 close-img"
          />
        </template>
        <PopUpsNewsletter
          @success="handleFinished"
          @close="clearFinished"
        />
      </BasicModal>
    </template>
    <template v-else-if="currentPopup.id === 'Storefinder'">
      <BasicModal class="lg" @close-modal="handleFinished()">
        <template #icon>
          <BasicIcon
            :name="'xmark-solid'"
            class="w-4 close-img"
          />
        </template>
        <PopUpsStoreFinder
          @success="handleFinished"
          @store-changed="handleFinished"
          @close="handleFinished"
        />
      </BasicModal>
    </template>
  </div>
</template>

<script setup lang="ts">
const { enqueue, currentPopup, next, clear } = usePopupQueue();
const route = useRoute();

function handleFinished() {
  next();
}
function clearFinished() {
  clear();
}

watch(
  () => route.hash,
  (newHash) => {
    if(newHash.includes("df5a532d-3a13-48df-b3a4-dba7b2b62fea") == true){
        enqueue({
            id: 'NL-SignUp',
        });
    }
  },
  { immediate: true }
)


</script>